<script>
    import Logo from "../Logo.svelte";
    import { fly } from "svelte/transition";
    import MediaQuery from "svelte-media-query";
    import ForwardButton from "../../common/buttons/ForwardButton.svelte";
    import BackwardButton from "../../common/buttons/BackwardButton.svelte";
    import { createEventDispatcher } from "svelte";
    import { _, locale } from "svelte-i18n";
    import { getLocale } from "../../util/locale";
    import LocaleMenu from "../menu/LocaleMenu.svelte";
    import { replace } from "svelte-spa-router";


    export let onSite = false;

    let scrollY = 0;

    const dispatch = createEventDispatcher();

    const locales = [
        {
            locale: "de",
            name: "Deutsch",
        },
        {
            locale: "fr",
            name: "Français",
        },
        {
            locale: "en",
            name: "English",
        },
    ];

    let currentLocale = getLocale();
    let openLocaleMenu = false;
    let flyAnimation = 600;

    function onChangeLocale(item) {
        $locale = item.locale;
        window.localStorage.setItem("locale", item.locale);
        currentLocale = item.locale;
    }

    function showLocaleMenu() {
        openLocaleMenu = true;
    }

    function hideLocaleMenu() {
        openLocaleMenu = false;
        currentLocale = getLocale();
    }
</script>

<svelte:window bind:scrollY />

<!--Locale switch -->
{#if openLocaleMenu}
    <LocaleMenu {flyAnimation} on:closeClicked={hideLocaleMenu} />
{/if}

<MediaQuery query="(min-width: 799px)" let:matches>
    {#if matches}
        <div style="background: var(--white-100);" class="fixed">
            <div class="header-grid">
                <div />
                <div
                    style="display: flex; align-items: center; justify-content: center"
                >
                    <Logo oneLine />
                </div>
                <div
                    style="display: flex; flex-direction: row; justify-content: end;"
                >
                    <div class="locale-selector" style="padding-right: 8px;">
                        {#each locales as item, index}
                            <div
                                style="cursor:pointer;"
                                on:click={() => onChangeLocale(item)}
                                class="text-l locale-label"
                                class:selected={item.locale === currentLocale}
                            >
                                {item.locale}
                            </div>
                            {#if index < locales.length - 1}
                                <div class="locale-divider" />
                            {/if}
                        {/each}
                    </div>
                    <div style="width: 24px;" />
                    <div
                        style="display: flex; justify-content: end; align-items: center"
                        on:click={() => dispatch("click")}
                        class="headline-custom pCursor"
                    >
                        <img style="width: 40px" src="./images/dashboard/burger-menu.svg" />
                    </div>
                </div>
            </div>
            {#if scrollY > 0}
                <div
                    transition:fly|local={{ x: -375, duration: 600 }}
                    class="divider-h"
                    style="min-height: 1px;"
                />
            {/if}
        </div>
        <div style="height: 64px; width: 100vw; margin-bottom: 24px" />
        <div
            style="display:flex; flex-direction:row; justify-content:right; margin-right: 56px; margin-bottom:24px;margin-top: 44px"
        >
            <BackwardButton on:click={() => dispatch("slideBackward")} />
            <ForwardButton on:click={() => dispatch("slideForward")} />
        </div>
       
    {:else}
        <div style="background: var(--white-100);" class="fixed">
            <div class="header-grid">
                <div />
                <div
                    style="display: flex; align-items: center; justify-content: center"
                >
                    {#if onSite}
                        <Logo oneLine on:click={() => replace("/onsite")} />
                    {:else}
                        <Logo oneLine on:click={() => replace("/")} />
                    {/if}
                </div>
                <div />
                <div
                    class="text-l locale-selector locale-label"
                    on:click={showLocaleMenu}
                >
                    {currentLocale}
                    <img
                        src="/images/icons/more.svg"
                        alt="Mehr zeigen"
                        class="locale-more"
                    />
                </div>
            </div>
            {#if scrollY > 130}
                <div
                    transition:fly|local={{ x: -375, duration: 600 }}
                    class="divider-h"
                    style="min-height: 1px;"
                />
            {/if}
        </div>
    {/if}
</MediaQuery>

<style>
    .fixed {
        position: fixed;
        width: 100vw;
        top: 0;
        left: 0;
        z-index: 1;
        box-sizing: border-box;
    }

    .logo {
        display: flex;
        justify-content: center;
        margin-top: 16px;
        margin-bottom: 12px;
    }

    .bar {
        position: fixed;
        width: 100vw;
        height: 76px;
        background: #f1f1ee;
        z-index: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .header-grid {
        display: grid;
        grid-template-columns: 2fr 4fr 1fr 1fr;
        min-height: 64px;
        padding: 0 32px 0 32px;
    }

    .locale-selector {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
    }

    .locale-label {
        text-transform: uppercase;
        color: var(--black-100);
        font-size: 14px;
        margin-top: 4px;
    }

    .locale-label:hover {
        color: var(--black-40);
    }

    .selected {
        color: var(--black-40);
    }

    .locale-divider {
        margin: 8px 8px;
        height: auto;
    }

    .headline-custom {
        font-family: "Trade Gothic LT Std", sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 96%;
        /* or 19px */
        letter-spacing: -0.02em;

        text-transform: uppercase;

        color: var(--black-100);
    }

    @media (min-width: 799px) {
        .header-grid {
            grid-template-columns: 2fr 4fr 2fr;
        }
    }
</style>
